// Door types

export const DOOR_TYPES = [
  { id: 'single', name: 'Single Door', defaultWidth: 36, icon: '🚪', description: 'Standard hinged door' },
  { id: 'double', name: 'Double Door', defaultWidth: 60, icon: '🚪🚪', description: 'Two-panel hinged' },
  { id: 'sliding', name: 'Sliding Door', defaultWidth: 72, icon: '↔️', description: 'Slides on track' },
  { id: 'pocket', name: 'Pocket Door', defaultWidth: 32, icon: '📥', description: 'Slides into wall' },
  { id: 'bifold', name: 'Bifold Door', defaultWidth: 48, icon: '📂', description: 'Folds in sections' },
  { id: 'french', name: 'French Door', defaultWidth: 60, icon: '🪟', description: 'Glass panel double' },
  { id: 'garage', name: 'Garage Door', defaultWidth: 192, icon: '🚗', description: 'Roll-up garage' },
  { id: 'barn', name: 'Barn Door', defaultWidth: 42, icon: '🚪', description: 'Exterior sliding' },
];
